__turbopack_context__.v({
  "background": "Hero-module-scss-module__71B27q__background",
  "foreground": "Hero-module-scss-module__71B27q__foreground",
  "hero": "Hero-module-scss-module__71B27q__hero",
  "image": "Hero-module-scss-module__71B27q__image",
  "image-overlay": "Hero-module-scss-module__71B27q__image-overlay",
  "simulation-form": "Hero-module-scss-module__71B27q__simulation-form",
  "title": "Hero-module-scss-module__71B27q__title",
});
